import { createSelector } from "@reduxjs/toolkit";

export const brandingSelector = createSelector<[(state: LSStore.State) => LSCommon.BrandedJsModel | null], LSCommon.BrandedJsModel | undefined>(state => state.branding.value, branding => branding || undefined);

export const getPortalUrl = (branding: LSCommon.BrandedJsModel | undefined): string | undefined => {
    if(branding 
        && branding.url 
        && branding.portalEnabled 
        && branding.portalType == LSCommon.Enums.BrandedPortalType.Mobility3)
        return branding.url;

    return undefined;
}